(() => {
  'use strict';

  const configNode = document.getElementById('lyopup-config');
  if (!configNode) return;

  const config = JSON.parse(configNode.textContent || '{}');
  const offer = config.launchOffer || {};
  const catalog = config.catalog || {};
  const root = config.root || '/';
  const nativeFetch = window.fetch.bind(window);
  let syncing = null;

  const normalizeId = (value) => {
    const match = String(value || '').match(/(\d{8,})/);
    return match ? match[1] : String(value || '');
  };

  const productsByVariant = new Map(
    Object.values(catalog)
      .filter((product) => product && product.variantId)
      .map((product) => [normalizeId(product.variantId), product]),
  );

  const isGift = (item) => String(item?.properties?._lyopup_launch_gift || '') === 'true';

  const paidBagCount = (cart) =>
    (cart.items || []).reduce((total, item) => {
      if (isGift(item)) return total;
      const product = productsByVariant.get(normalizeId(item.variant_id || item.id));
      return total + (Number(product?.bags) || 1) * Number(item.quantity || 0);
    }, 0);

  const request = async (path, body) => {
    const response = await nativeFetch(root + path, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        ...(body ? { 'Content-Type': 'application/json' } : {}),
      },
      ...(body ? { body: JSON.stringify(body) } : {}),
    });
    if (!response.ok) throw new Error('Launch offer cart synchronization failed');
    return response.json();
  };

  const synchronizeGift = () => {
    if (syncing) return syncing;
    syncing = (async () => {
      const cart = await request('cart.js');
      const gift = (cart.items || []).find(isGift);

      if (!offer.enabled) {
        if (gift) await request('cart/change.js', { id: gift.key, quantity: 0 });
        return;
      }

      const eligible = paidBagCount(cart) >= Number(offer.threshold || 6);
      if (eligible && gift && Number(gift.quantity) !== 1) {
        await request('cart/change.js', { id: gift.key, quantity: 1 });
      } else if (!eligible && gift) {
        await request('cart/change.js', { id: gift.key, quantity: 0 });
      }
    })()
      .catch((error) => console.error('LyoPup launch offer:', error))
      .finally(() => {
        syncing = null;
      });
    return syncing;
  };

  window.fetch = async (input, init) => {
    const response = await nativeFetch(input, init);
    const url = String(typeof input === 'string' ? input : input?.url || '');
    if (/\/cart\/(add|change|update)\.js(?:\?|$)/.test(url)) {
      await synchronizeGift();
    }
    return response;
  };

  document.addEventListener('DOMContentLoaded', synchronizeGift);
  window.addEventListener('pageshow', synchronizeGift);
})();
